<template>
  <div>
    <div id="home"></div>

    <v-carousel
            class="text-xs-center rooms-img"
            height="70vh"
    >
      <v-carousel-item
        dark
        v-for="offer in offers"
        :key="offer.id"
        :src="offer.img"
      >
        <div class="offer1-mask">
          <v-container>

            <div class="offer1-offer">{{ offer.offer1 }}</div>
            <div class="offer1-sub-offer">{{ offer.offer2 }}</div>

            <app-modal-form
              :button-text="offer.buttonText"
              :modal-form-header="offer.formHeader"
              :modal-form-sub-header="offer.formSubHeader"
              :modal-form-button-text="offer.formButtonText"
              :form-name="offer.formName"
            ></app-modal-form>

          </v-container>
        </div>
      </v-carousel-item>
    </v-carousel>

    <app-acropolis-plus class-name="screen"></app-acropolis-plus>
    <app-acropolis-services></app-acropolis-services>
    <app-acropolis-gallery></app-acropolis-gallery>
    <app-acropolis-reviews></app-acropolis-reviews>
    <app-acropolis-contacts></app-acropolis-contacts>

  </div>
</template>

<script>
export default {
  data () {
    return {
      offers: [
        {
          id: 1,
          offer1: 'Посуточная и почасовая аренда апартаментов',
          offer2: 'Бесплатный трансфер, Wi-Fi, полноценная кухня.',
          img: '/static/img/home/acropolis/home1.jpg',
          buttonText: 'Забронировать номер',
          formHeader: 'Забронируйте',
          formSubHeader: 'номер прямо сейчас',
          formButtonText: 'Забронировать номер',
          formName: 'Акрополь - Главный экран'
        },
        {
          id: 2,
          offer1: '3 сауны с бассейном на выбор',
          // offer2: 'Пятый час в подарок! При оплате четырех часов, пятый час вы получаете в подарок.',
          offer2: ' ',
          img: '/static/img/home/acropolis/home5.jpg',
          buttonText: 'Забронировать сауну',
          formHeader: 'Забронируйте',
          formSubHeader: 'сауну прямо сейчас',
          formButtonText: 'Забронировать сауну',
          formName: 'Акрополь - Главный экран'
        },
        {
          id: 3,
          offer1: 'Скидка имениннику 10%',
          offer2: 'Если вы бронируете проведение своего дня рождения у нас, то вы получаете скидку 10%.',
          img: '/static/img/home/acropolis/home6.jpg',
          buttonText: 'Забронировать кафе',
          formHeader: 'Забронируйте',
          formSubHeader: 'кафе прямо сейчас',
          formButtonText: 'Забронировать кафе',
          formName: 'Акрополь - Главный экран - Кафе'
        },
        {
          id: 4,
          offer1: 'Бильярдная комната',
          offer2: 'В вашем распоряжении комната для бильярда! Можете провести время со своими друзьями розыграв партию.',
          img: '/static/img/home/acropolis/home4.jpg',
          buttonText: 'Забронировать бильярд',
          formHeader: 'Забронируйте',
          formSubHeader: 'бильярд прямо сейчас',
          formButtonText: 'Забронировать бильярд',
          formName: 'Акрополь - Главный экран'
        }
      ]
    }
  }
}
</script>

<style scoped>
#home {
  position: relative;
  top: -150px;
}

.rooms-img {
  height: 80vh;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Acropolis.vue